import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { getItemsFromCollection } from "directus/src/operations";
import Loader from "@/components/loader";

const CurrencyContext = createContext();

export const useCurrencies = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error("useCurrencies must be used within a CurrencyProvider");
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const {
    data: currencies = [],
    isLoading,
    error,
  } = useQuery({
    queryKey: ["currencies"],
    queryFn: async () => {
      const currenciesQuery = {
        limit: -1,
      };
      return await getItemsFromCollection("currencies", currenciesQuery);
    },
  });

  // Centralized currency conversion utility
  const convertToINR = (amount, currencyId) => {
    if (amount === null || amount === undefined || amount === '' || amount === 0) return 0;
    
    const numAmount = Number(amount);
    if (isNaN(numAmount)) return 0;
    
    if (!currencyId) return numAmount;

    const currency = currencies.find((c) => c.id === currencyId);
    if (!currency) {
      return numAmount;
    }

    const conversionRate = Number(currency.budget_rate_inr);
    const rate = isNaN(conversionRate) || conversionRate === 0 ? 1 : conversionRate;
    
    const calculatedAmount = numAmount * rate;
    return calculatedAmount;
  };

  const value = {
    currencies,
    isLoading,
    error,
    convertToINR,
  };

  

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
};
